<template>
  <div id="view2" class="lv1Text">
    <div class="bread container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/commend'}">特惠专区</el-breadcrumb-item>
        <el-breadcrumb-item>商品详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div style="background-color:#fff;padding:20px 0;">
      <div class="container">
        <el-row :gutter="20">
          <el-col :span="7">
            <div style="border:1px solid #ddd;padding:10px;">
              <el-image class="cover" :src="serve  + data.images" fit="cover"></el-image>
            </div>
          </el-col>
          <el-col :span="17">
            <div>
              <el-row>
                <el-col :span="14">
                  <div style="font-size:20px">{{data.title}}</div>
                </el-col>
                <el-col :span="4" align="right">
                  <div class="lv0Text" style="font-size:30px">&yen;{{data.discount_price}}</div>
                  <div class="lv3Text">特惠价</div>
                </el-col>
                <el-col :span="4" align="right">
                  <div class="lv3Text" style="font-size:30px">
                    <s>&yen;{{data.selling_price}}</s>
                  </div>
                  <div class="lv3Text">原价</div>
                </el-col>
              </el-row>
            </div>
            <div class="box">
              <div class="t1">特惠商品 享{{data.discount_num}}折</div>
              <div style="padding:10px;">
                <div style="padding: 10px 0">
                  <span>特惠价:</span>
                  <span
                    class="lv0Text"
                    style="font-size:20px;margin-left:10px"
                  >&yen;{{data.discount_price}}</span>
                  <span class="lv3Text" style="margin-left:10px">
                    <s>&yen;{{data.selling_price}}</s>
                  </span>
                </div>
                <div style="padding: 10px 0" class="lv3Text">
                  <i class="fas fa-check-circle"></i> 服务承诺
                  <i class="fas fa-check-circle" style="margin-left:10px;"></i> 正品保证
                  <i class="fas fa-check-circle" style="margin-left:10px;"></i> 极速发货
                </div>
              </div>
            </div>

            <div style="margin:20px 0;">
              <el-input-number v-model="number" :min="1" :max="99" label="数量：" size="medium"></el-input-number>
            </div>
            <div>
              <el-button class="btn" @click="add">加入购物车</el-button>
              <el-button type="primary" class="btn" @click="buy">立即购买</el-button>
              <el-button
                plain
                size="mini"
                style="float:right"
                @click="addFv"
                v-if="isFav==false&&$store.state.isLogin==true"
              >
                <i class="fas fa-star" style="margin-right:5px;"></i>收藏
              </el-button>
              <el-button
                plain
                size="mini"
                style="float:right"
                @click="cancelFv"
                v-if="isFav==true&&$store.state.isLogin==true"
              >
                <i class="fas fa-star" style="margin-right:5px;"></i>已收藏
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="container" style="margin-top:20px;">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-tabs type="border-card">
              <el-tab-pane label="商品详情">
                <div style="padding: 0 20px;margin-bottom:30px">
                  <el-row>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>商品名称：{{data.title}}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>商品规格：{{data.specification}}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>品牌：{{data.brand}}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>货期：{{data.leadtime}}天</span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>货号：{{data.item_no}}</span>
                      </div>
                    </el-col>
                    <el-col :span="12" class="r2">
                      <div class="r1">
                        <span>产品分类：{{data.classification}}</span>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div style="margin-bottom:20px" v-if="data.download_link">
                  <div class="t3 lv1Text">下载文档</div>
                  <div>
                    <router-link :to="serve +data.download_link">下载文档</router-link>
                  </div>
                </div>

                <div>
                  <div class="t3 lv1Text">详情</div>
                  <div>
                    <div v-html="data.info"></div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="评价" style="padding: 20px 10px;">
                <div v-for="(item,index) of comments" :key="index" class="comment-item">
                  <div class="clear top1">
                    <div class="clear-item">
                      <img :src="item.headImg" class="avatar">
                    </div>
                    <div class="clear-item lv3Text" style="margin:0 10px;">{{item.nickname}}</div>
                    <div class="clear-item" v-if="item.rank">
                      <el-rate
                        class="ra"
                        disabled
                        :value="_.toInteger(item.rank)"
                        :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                      ></el-rate>
                    </div>
                  </div>
                  <el-row>
                    <el-col :span="20" :offset="4">
                      <div class="lv2Text">{{item.content}}</div>
                      <div
                        class="lv3Text"
                        style="font-size:12px;margin:10px 0 5px 0;"
                      >{{dayjs.unix(item.create_date).format('YYYY-MM-DD hh:mm:ss')}}</div>
                    </el-col>
                  </el-row>
                </div>
                <div class="pager" align="center">
                  <el-pagination
                  hide-on-single-page
                    @current-change="pageChange"
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="10"
                  ></el-pagination>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="hot" align="center">
            <div class="t2">热销榜</div>
            <div v-for="(item,index) in hot" :key="index" class="hot-item">
              <img :src="serve +item.images" class="cover2">
              <router-link :to="'/view?id='+item.id">
                <div style="margin:10px 0;" class="title">
                  {{
                  _.truncate(item.title, {
                  'length': 15,
                  })
                  }}
                </div>
              </router-link>
              <div class="lv0Text" style="margin-bottom:10px">&yen;{{item.selling_price}}</div>
            </div>
          </div>

          <div class="hot" align="center">
            <div class="t2">技术服务</div>
            <div v-for="(item,index) in server" :key="index" class="hot-item">
              <img :src="serve +item.images" class="cover2">
              <router-link :to="'/view?id='+item.id">
                <div style="margin:10px 0;" class="title">
                  {{
                  _.truncate(item.title, {
                  'length': 15,
                  })
                  }}
                </div>
              </router-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      id: 0,
      data: {},
      number: 1,
      page: 1,
      comments: {},
      total: 0,
      hot: {},
      server: {},
      isFav: false
    };
  },
  watch: {
    $route: "initData"
  },
  created() {
    this.initData();
  },
  methods: {
    cancelFv() {
      this.axios
        .get(this.serve + "/member/cancel_collect", {
          params: {
            id: this.$route.query.id,
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.isFav = false;
          }
        });
    },
    addFv() {
      this.axios
        .get(this.serve + "/member/add_collect", {
          params: {
            id: this.$route.query.id,
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.isFav = true;
          }
        });
    },
    add() {
      if (this.$store.state.isLogin) {
        this.axios
          .get(this.serve + "/member/add_car", {
            params: {
              mobile: this.$cookies.get("user"),
              token: this.$cookies.get("token"),
              id: this.id,
              number: this.number
            }
          })
          .then(res => {
  
            if (res.data.status == "success") {
              this.$message("商品已加入购物车");
            } else {
              this.$message.error(res.data.msg);
            }
          });
      } else {
        this.$router.push("/login");
      }
    },
    buy() {
      var json = {
        id: this.data.id,
        title: encodeURIComponent(this.data.title),
        item_no: this.data.item_no,
        number: this.number,
        selling_price: this.data.discount_price,
        images: this.data.images
      };
      this.$router.push({ path: "/user/order", query: json });
    },
    pageChange(v) {
      this.page = v;
      this.axios
        .get(this.serve + "/get_product_comment", {
          params: {
            product_id: this.data.id,
            page: this.page
          }
        })
        .then(res => {
          this.comments = res.data.data.results;
          this.total = res.data.data.total;
        });
    },
    initData() {
      this.id = this.$route.query.id;
      this.axios
        .get(this.serve + "/get_product_info", {
          params: {
            id: this.$route.query.id
          }
        })
        .then(res => {
          this.data = res.data.info;
          this.hot = res.data.hot;
          this.server = res.data.serve;
          this.axios
            .get(this.serve + "/get_product_comment", {
              params: {
                product_id: this.data.id,
                page: this.page
              }
            })
            .then(res => {
           
              if (res.data.data !== undefined) {
                this.comments = res.data.data.results;
                this.total = res.data.data.total;
              }
            });
        });
    }
  }
};
</script>
<style lang="scss">
#view2 {
  .t3 {
    background-color: #eaeaea;
    padding: 10px 0;
    text-align: center;
  }
  .avatar {
    height: 50px;
    width: 50px;
    border-radius: 50px;
  }
  .t2 {
    text-align: center;
    padding: 10px 0;
    background-color: #eee;
    margin-bottom: 20px;
  }
  .cover2 {
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;
  }
  .hot {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid #ddd;
    .title:hover {
      text-decoration: underline;
    }
  }
  .hot-item {
    width: 90%;
    margin-bottom: 20px;
    border: 1px solid #ddd;
  }
  .r2 {
    padding-right: 30px;
  }
  .r1 {
    padding: 10px 0;
    border-bottom: 2px dashed #ddd;
  }
  .comment-item {
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    margin-bottom: 20px;
  }
  .btn {
    width: 150px;
    margin-right: 50px;
  }
  .box {
    background-color: #f2f2f2;
    border: 1px solid #ddd;
    margin-top: 20px;
    width: 80%;
    .t1 {
      background-color: #e36844;
      color: #fff;
      padding: 10px;
    }
  }
  padding: 0 0 50px 0;
  .cover {
    height: 315px;
    width: 315px;
    background-position: center;
    background-size: 100% auto;
  }
}
</style>